/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}TrainDetails`,
    file: 'TrainDetails',
    path: `${payload.location === 'ProjectWallet'?':selected_column/':''}trains/:train_id`,
    folder: 'Project/TrainTaktareaDetails',
    auth:true,
    children: [
      UltraRoute({name: `${payload.location}TaktareaDetails`, file: 'TaktareaDetails', path: 'taktareas/:taktarea_id', folder: 'Project/TrainTaktareaDetails', auth:true, redirect: `${payload.location}TaktareaDetailsInfo`, children: [
        UltraRoute({name: `${payload.location}TaktareaDetailsInfo`, file: 'TaktareaDetailsInfo', path: 'info', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsQRCodes`, file: 'TaktareaDetailsQRCodes', path: 'qrcodes', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsQRCodesDetails`, file: 'TaktareaDetailsQRCodesDetails', path: 'qrcodes/:content_id', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsSteps`, file: 'TaktareaDetailsSteps', path: ':step_type/steps', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsStepsDetails`, file: 'TaktareaDetailsStepsDetails', path: ':step_type/steps/:step_id', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsSequence`, file: 'TaktareaDetailsSequence', path: 'sequence', folder: 'Project/TrainTaktareaDetails', auth: true}),
        UltraRoute({name: `${payload.location}TaktareaDetailsQuantities`, file: 'TaktareaDetailsQuantities', path: 'quantities', folder: 'Project/TrainTaktareaDetails', auth: true}),
      ]}),
    ]
  });
  return route;
}
export default Template;
